<template>
  <!-- 休日出勤報告一覧 -->
  <div id="monthlyreport">
    <CCard>
      <CCardHeader><h2>休日出勤報告一覧</h2></CCardHeader>
      <CCardBody>
        <table class="table search-table">
          <tr>
            <th style="width: 100px">年月</th>
            <th style="width: 75px"></th>
            <th style="width: 50px"></th>
            <th style="width: 220px"></th>
            <th colspan="2"></th>
          </tr>
          <tr>
            <td>
              <select
                class="custom-select preika-control--year"
                v-model="year"
              >
                <option
                  v-for="option in yearOption"
                  :value="option.id"
                  :key="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </td>
            <td>
              <select
                class="custom-select preika-control--month"
                v-model="month"
              >
                <option
                  v-for="option in monthOption"
                  :value="option.id"
                  :key="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </td>
            <td>業務分</td>
            <!--
              年月と同じ行に置く。検索ボタンは1つのままで、
              年・月・言葉をまとめて送る。
            -->
            <td>
              <input
                v-model="keyword"
                type="text"
                class="form-control"
                style="width: 220px; max-width: 100%"
                maxlength="100"
                placeholder="社員番号・氏名・所属で絞り込む"
                @keyup.enter="applySearch"
              />
            </td>
            <td>
              <button class="btn btn-primary" @click="applySearch">検索</button>
            </td>
          </tr>
        </table>
      </CCardBody>
      <template v-if="callFlg">
        <CCardBody>
          <div class="table-responsive">
            <table class="table table-bordered preika-report-list-table">
              <thead>
                <tr>
                  <th scope="col">社員名</th>
                  <th scope="col">日付</th>
                  <th scope="col">予定時刻</th>
                  <th scope="col">発生理由</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>
                    <router-link
                      :to="{
                        name: holidayWorksMsterInfo,
                        params: { id: item.id },
                      }"
                      >{{ item.user_name }}</router-link
                    >
                  </td>
                  <td class="preika-report-list-table__date">{{ formatDate(item.date) }}</td>
                  <td class="preika-report-list-table__time">
                    {{ formatTime(item.start_time) }}<template v-if="item.end_time">～</template>{{ formatTime(item.end_time) }}
                  </td>
                  <td class="preika-report-list-table__reason">{{ item.reason }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="d-flex justify-content-center">
            <VPagination
              v-model="currentPage"
              :click-handler="changePage"
              :page-count="totalPages"
              :force-page="currentPage"
              :force-ellipses="true"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :prev-text="'<'"
              :next-text="'>'"
              :prev-link-class="'page-link'"
              :next-link-class="'page-link'"
              :page-link-class="'page-link'"
              :class-prefix="'pagination'"
            />
          </div>
        </CCardBody>
      </template>
    </CCard>
  </div>
</template>

<script>
import ConstList from "../../ConstList";
import axios from "axios";
import moment from "moment";
import VPagination from "vuejs-paginate";
export default {
  name: "MonthlyReport",
  components: {
    VPagination,
  },
  data() {
    return {
      year: "",
      month: "",
      date: "",
      // いま効いている絞り込みの言葉。空なら絞り込んでいない。
      keyword: "",
      items: [],
      callFlg: false,
      type_options: [ConstList.ALLDAY, ConstList.MORNING, ConstList.AFTERNOON],
      holidayWorksMsterInfo: "",
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
    };
  },
  created() {
    this.yearOption = ConstList.YEAR_OPTION;
    this.monthOption = ConstList.MONTH_OPTION;
    this.holidayWorksMsterInfo = ConstList.ROUTE_HOLIDAYWORKS_MASTERINFO;
  },

  methods: {
    formatTime(timeString) {
      if (!timeString) return "";

      const [hours, minutes] = timeString.split(":");
      return `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}`;
    },
    /**
     * 検索ボタン・Enterから呼ぶ。
     *
     * **ページを1へ戻す。**5ページ目のまま絞り込むと、結果が1ページ
     * しか無いときに空の表になる。ページ送り（changePage）からは
     * 呼ばないので、めくった位置はそのまま残る。
     */
    applySearch: function () {
      this.currentPage = 1;
      this.callList();
    },
    callList: function () {
      this.callFlg = false;
      const params = new URLSearchParams();
      params.append("year", this.year);
      params.append("month", this.month);
      this.fetchTotalPages();
      params.append("currentPage", this.currentPage);
      params.append("pageSize", this.pageSize);
      params.append("totalPages", this.totalPages);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/admin/holidaywork", {
          params: {
            year: this.year,
            month: this.month,
            currentPage: this.currentPage,
            pageSize: this.pageSize,
            // 空文字は渡さない。渡すと「空で絞り込む」形になりうる。
            keyword: this.keyword || undefined,
          },
        })
        .then((response) => {
          this.items = response.data;
          this.callFlg = true;
          sessionStorage.setItem(
            "holidayworkList-search-items",
            JSON.stringify(this.items)
          );
          sessionStorage.setItem(
            "holidayworkList-search-params",
            JSON.stringify({
              year: this.year,
              month: this.month,
              // 戻ってきたときに年月と同じように絞り込みも戻す。
              keyword: this.keyword,
              currentPage: this.currentPage,
              pageSize: this.pageSize,
              totalPages: this.totalPages,
            })
          );
        })
        .catch((error) => {
        axios
          .post(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError`,
            { error: String(error) },
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        });
    },
    statusColor(status) {
      switch (status) {
        case ConstList.REJECT:
        case ConstList.UNSUBMITTED:
          return { color: 'red' };
        case ConstList.APPROVAL_PENDING:
          return { color: 'orange' };
        case ConstList.APPROVAL:
          return { color: 'green' };
        default:
          return {};
      }
    },
    changePage: function (page) {
      this.currentPage = page;
      this.callList();
    },
    fetchTotalPages: function () {
      const params = new URLSearchParams();
      params.append("year", this.year);
      params.append("month", this.month);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/admin/holidaywork/count", {
          params: {
            year: this.year,
            month: this.month,
            // 一覧と同じ言葉で数える。片方だけだとページ送りが壊れる。
            keyword: this.keyword || undefined,
          },
        })
        .then((response) => {
          const totalCount = response.data;
          // **ページ数は最低1。**Math.ceil(0 / 10) は 0 で、0件のときに
          // ページャそのものが消えてしまう。
          this.totalPages = Math.max(1, Math.ceil(totalCount / this.pageSize));
          // 数え直したあとに、見ているページを 1〜totalPages へ収める。
          // 覚えていたページへ戻ったとき、そのあいだに件数が減っていると
          // 空の表になるので、収めた側で引き直す。
          const inRange = Math.min(Math.max(1, this.currentPage), this.totalPages);
          if (inRange !== this.currentPage) {
            this.currentPage = inRange;
            this.callList();
          }
        })
        .catch((error) => {
        axios
          .post(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError`,
            { error: String(error) },
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        });
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const [yyyy, mm, dd] = dateStr.split('-');
      return `${yyyy}/${mm}/${dd}`;
    },
  },
  mounted: function () {
    // **確かめる鍵と、読む鍵を同じにする。**別の鍵（-items）の有無で
    // 判定して -params を読むと、片方だけ残っているときに
    // JSON.parse(null) で落ちる。
    const saved = sessionStorage.getItem("holidayworkList-search-params");
    if (saved) {
      const params = JSON.parse(saved);
      this.year = params.year;
      this.month = params.month;
      // 保存が無い頃の値が残っていても壊れないよう、空で受ける。
      this.keyword = params.keyword || "";
      // **見ていたページへ戻す。**保存しているのだから復元する。
      // 件数が減っていることがあるので、数え直したあと
      // （fetchTotalPages）に 1〜totalPages へ収める。
      this.currentPage = Number(params.currentPage) || 1;
      this.callList();
      this.callFlg = true;
    } else {
      const today = moment().subtract(1, 'months');
      this.year = today.format("YYYY");
      this.month = today.format("M");
    }
  },
};
</script>
